<template>
    <div class="widget_counter">
        <!--위젯카운터 -->
        <div class="item">
            <font-awesome-icon :icon="['fas', 'user-check']" /> 
            <span :class="{new:online>1,liveUser:online>1}" >{{online}}</span>
           
        </div>
        <div class="item" @click="link('admin/goods/buylist/all')">
            <font-awesome-icon :icon="['fas', 'shopping-cart']" /> 
            <span :class="{new:newGoodsBuy > 0}">{{newGoodsBuy}}</span>
            <span class="alarm_spot" :class="{animate:newGoodsBuy>0}"></span>
        </div>
        <div class="item" @click="link('admin/goods/buylist/all')">
            <font-awesome-icon :icon="['fas', 'undo-alt']" /> 
            <span :class="{new:newRefund > 0}">{{newRefund}}</span>
            <span class="alarm_spot" :class="{animate:newRefund>0}"></span>
        </div>

    </div>
</template>
<script>
export default {
    name:'widget_counter',
    props:[
        'online' ,'newGoodsBuy',
        'newRefund'  
    ],
    data(){
        return{

        }
    },
    mixins:[

    ],
    components:{

    },
    mounted() {
    },
    methods:{
        link(url){
            window.parent.location.href = this.$store.state.serverDomain2+ url; 
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/ani_infinite";
.widget_counter{
    display: flex;
    justify-content: space-evenly;    
    padding:10px 0 1px 0;    
    background:#fff;
    .item{
        background-color: rgba(243,244,246,1);   
        border-radius: 9999px; 
        padding: .5rem;
        cursor: pointer;
        position: relative;
        font-size:20px;
        color:rgba(107,114,128,1);
        span{            
            position: absolute;
            right: -5px; 
            top:0;
            background:rgb(143, 143, 143);   
            border-radius: 9999px;
            padding:2px 5px;
            font-size:11px;
            color:#fff;
        }
        .new{
             background:rgba(248,113,113,1);      
        }
        .alarm_spot{
            width:15px;
            height:15px;
            background:rgba(248,113,113,0);   
        }
        .liveUser{
            background:rgba(248,113,113,1);      
        }
        .animate{
            animation: ping 1s cubic-bezier(0,0,.2,1) infinite;  
          
            background:rgba(248,113,113,1);   
        }
    }
    .item:hover{
        background-color: rgb(223, 223, 223);       
    }
}
</style>
